<template>
    <footer class="footer has-cards">
        <div class="container">
            <div class="row row-grid align-items-center my-md">
                <div class="col-lg-6">
                    <h3 class="txt-primary font-weight-bold mb-2">Chegou sua vez!</h3>
                    <h4 class="mb-0 font-weight-light">Auxílio Maternidade é com a AMO.</h4>
                </div>
                <div class="col-lg-6 text-lg-center btn-wrapper">
                  <a target="_blank" rel="noopener" href="https://www.facebook.com/AuxilioMaternidadeOfic/"
                     class="btn btn-neutral btn-icon-only btn-facebook btn-round btn-lg" data-toggle="tooltip"
                     data-original-title="Acessar Agora">
                    <i class="fa fa-facebook-square"></i>
                  </a>
                    <a target="_blank" rel="noopener" href="https://www.instagram.com/auxiliomaternidadeoficial/"
                       class="btn btn-neutral btn-icon-only btn-instagram btn-round btn-lg" data-toggle="tooltip"
                       data-original-title="Acessar Agora">
                        <i class="fa fa-instagram"></i>
                    </a>
                    <a target="_blank" rel="noopener" href="https://www.youtube.com/channel/UCw1RMbFJ6d9Ez4LtV1xgE8A"
                       class="btn btn-neutral btn-icon-only btn-youtube btn-lg btn-round" data-toggle="tooltip"
                       data-original-title="Acessar Agora">
                        <i class="fa fa-youtube"></i>
                    </a>
                    <a target="_blank" rel="noopener" href="https://auxiliomaternidadeoficial.com.br"
                       class="btn btn-neutral btn-icon-only btn-slack btn-round btn-lg" data-toggle="tooltip"
                       data-original-title="Acessar Site">
                        <i class="fa fa-globe"></i>
                    </a>
                </div>
            </div>
            <hr>
            <div class="row align-items-center justify-content-md-between">
                <div class="col-md-6">
                    <div class="copyright">
                        <p>&copy; {{year}} Guide Creations</p>
                    </div>
                </div>
                <div class="col-md-6">
                    <ul class="nav nav-footer justify-content-end">
                        <li class="nav-item">
                            <a href="https://auxiliomaternidadeoficial.com.br" class="nav-link" target="_blank" rel="noopener">Site AMO</a>
                        </li>
                        <li class="nav-item">
                            <a href="https://auxiliomaternidadeoficial.com.br/blog/" class="nav-link" target="_blank" rel="noopener">Blog AMO</a>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </footer>
</template>
<script>
export default {
  name: 'app-footer',
  data () {
    return {
      year: new Date().getFullYear()
    }
  }
}
</script>
<style lang="scss" scoped>
@import "src/assets/scss/my-custom.scss";

.bottom-whats {
  position: fixed;
  width: 70px;
  height: 70px;
  bottom: 15px;
  right: 15px;
  background-color: $success;
  color: #FFF;
  border-radius: 50px;
  font-size: 2rem;
  box-shadow: 1px 1px 2px #888;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  z-index: 999;
}
.txt-primary {
  color: $my-primary;
}
</style>
